// Write your JS code here
import {Component} from 'react'
import CryptocurrencyItem from '../CryptocurrencyItem'
import './index.css'

class CryptocurrenciesList extends Component {
  render() {
    const {cryptoData} = this.props

    return (
      <div className="cryptocurrencies-list-container">
        <h1 className="main-heading">Cryptocurrency Tracker</h1>
        <img
          src="https://assets.ccbp.in/frontend/react-js/cryptocurrency-bg.png"
          alt="cryptocurrency"
          className="cryptocurrency-img"
        />
        <div className="crypto-table">
          <div className="table-header">
            <p className="header-cell currency-type">Coin Type</p>
            <div className="currency-values-header">
              <p className="header-cell value-cell">USD</p>
              <p className="header-cell value-cell">EURO</p>
            </div>
          </div>
          <ul className="list-items-container">
            {cryptoData.map(eachCrypto => (
              <CryptocurrencyItem
                key={eachCrypto.id}
                cryptoDetails={eachCrypto}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default CryptocurrenciesList
